import { PluginType } from '@Generated/back-office-client/src'
import { formatEnumLabel, getRealEnumValues } from '@Components/util/utils'

export type PluginSlot = {
  type: PluginType
  label: string
  refId?: string
}

// Per-type overrides. Any type absent here gets one slot with a humanized label.
// Use this for acronym casing (KYC) and multi-instance plugins (refId fan-out).
const SLOT_OVERRIDES: Partial<Record<PluginType, PluginSlot[]>> = {
  [PluginType.KYC_VERIFICATION]: [{ type: PluginType.KYC_VERIFICATION, label: 'KYC Verification' }],
  [PluginType.PLAYER_AUTH]: [
    { type: PluginType.PLAYER_AUTH, label: 'Player Auth' },
    {
      type: PluginType.PLAYER_AUTH,
      label: 'Player Auth — Redeem Reward',
      refId: 'REDEEM_REWARD',
    },
  ],
  [PluginType.PLAYER_ELIGIBILITY]: [
    { type: PluginType.PLAYER_ELIGIBILITY, label: 'Player Eligibility' },
    {
      type: PluginType.PLAYER_ELIGIBILITY,
      label: 'Player Eligibility — Redeem Reward',
      refId: 'REDEEM_REWARD',
    },
  ],
  [PluginType.REWARD_ASSIGNMENT]: [
    { type: PluginType.REWARD_ASSIGNMENT, label: 'Reward Assignment — Entries', refId: 'ENTRIES' },
    {
      type: PluginType.REWARD_ASSIGNMENT,
      label: 'Reward Assignment — In Store',
      refId: 'IN_STORE',
    },
    { type: PluginType.REWARD_ASSIGNMENT, label: 'Reward Assignment — Online', refId: 'ONLINE' },
    { type: PluginType.REWARD_ASSIGNMENT, label: 'Reward Assignment — Cash', refId: 'CASH' },
  ],
}

// Auto-derived from the generated PluginType enum: every real plugin type renders a slot
// (humanized label by default), so new backend plugins appear without editing this file.
// Add a SLOT_OVERRIDES entry only to fix the label or fan a type out across refIds.
export const PLUGIN_SLOTS: PluginSlot[] = getRealEnumValues(PluginType).flatMap(
  (type) => SLOT_OVERRIDES[type] ?? [{ type, label: formatEnumLabel(type) }],
)
